import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface FuncionHistorialComite {
  id?: number;
  n_comite: number;
  cedula: number;
  funcion: number;
  estado?: number;
  fechacreacion?: string | Date;
  fechamodificacion?: string | Date;
}

@Injectable({
  providedIn: 'root',
})
export class FuncionHistorialComiteService {
  private apiUrl = `${environment.apiUrl}/api/funcion-historial-comite`;

  constructor(private http: HttpClient) {}

  /**
   * Obtiene todas las relaciones históricas de funciones por comité
   */
  getAll(): Observable<FuncionHistorialComite[]> {
    return this.http
      .get<FuncionHistorialComite[]>(this.apiUrl)
      .pipe(catchError((error) => this.manejarError(error)));
  }

  /**
   * Obtiene solo los registros activos (estado = 1)
   */
  getActivos(): Observable<FuncionHistorialComite[]> {
    return this.http
      .get<FuncionHistorialComite[]>(`${this.apiUrl}/activos`)
      .pipe(catchError((error) => this.manejarError(error)));
  }

  /**
   * Obtiene un registro por su ID
   */
  getById(id: number): Observable<FuncionHistorialComite> {
    return this.http
      .get<FuncionHistorialComite>(`${this.apiUrl}/${id}`)
      .pipe(catchError((error) => this.manejarError(error)));
  }

  /**
   * Obtiene todos los registros históricos de un comité específico
   */
  getByNumeroComite(n_comite: number): Observable<FuncionHistorialComite[]> {
    return this.http
      .get<FuncionHistorialComite[]>(`${this.apiUrl}/comite/${n_comite}`)
      .pipe(catchError((error) => this.manejarError(error)));
  }

  /**
   * Crea un nuevo registro histórico de función por comité
   */
  create(data: FuncionHistorialComite): Observable<FuncionHistorialComite> {
    return this.http
      .post<FuncionHistorialComite>(this.apiUrl, data)
      .pipe(catchError((error) => this.manejarError(error)));
  }

  /**
   * Actualiza un registro existente
   */
  update(id: number, data: FuncionHistorialComite): Observable<FuncionHistorialComite> {
    return this.http
      .put<FuncionHistorialComite>(`${this.apiUrl}/${id}`, data)
      .pipe(catchError((error) => this.manejarError(error)));
  }

  /**
   * Elimina (soft delete) un registro
   */
  remove(id: number): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`)
      .pipe(catchError((error) => this.manejarError(error)));
  }

  /**
   * Activa un registro (cambia estado a 1)
   */
  activate(id: number): Observable<FuncionHistorialComite> {
    return this.http
      .patch<FuncionHistorialComite>(`${this.apiUrl}/${id}/activate`, {})
      .pipe(catchError((error) => this.manejarError(error)));
  }

  /**
   * Maneja errores de las solicitudes HTTP
   */
  private manejarError(error: any): Observable<never> {
    let errorMessage = 'Ocurrió un error en la solicitud';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Código de error: ${error.status}, Mensaje: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
